const MO_CARD_DATA_KEY = 'mo-card-data';

export function saveMoCardData(number, code = null) {
  const moCard = { card_number: number };

  if (code !== null) {
    moCard.pin_code = code;
  }

  localStorage.setItem(MO_CARD_DATA_KEY, JSON.stringify(moCard));
}

export function getMoCardData() {
  const moCard = localStorage.getItem(MO_CARD_DATA_KEY);

  if (!moCard) {
    return null;
  }

  return JSON.parse(moCard);
}

export function clearMoCardData() {
  localStorage.removeItem(MO_CARD_DATA_KEY);
}
